import React from 'react';

const AddressAutocomplete = ({ 
  value, 
  onChange, 
  onAddressSelect, 
  placeholder = "Enter your address",
  className = "",
  required = false,
  name = "address"
}) => {
  // For now, this is a simple input field
  // TODO: Implement proper address autocomplete with a working API service
  
  return (
    <input
      type="text"
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      required={required}
      autoComplete="street-address"
    />
  );
};

export default AddressAutocomplete; 